// WebKit can retain a failed module response across a normal document reload. Refresh only assets this
// document actually requested; never infer a URL from an exception or refresh application/vendor endpoints.
export async function refreshD2cStaticAssets() {
  if (typeof window.performance.getEntriesByType !== "function") return
  const assets = new Set()
  for (const entry of window.performance.getEntriesByType("resource")) {
    try {
      const url = new URL(entry.name)
      if (url.origin !== window.location.origin || url.username || url.password || url.search || url.hash) continue
      if (!/^\/vite(?:-test)?\/assets\/[A-Za-z0-9_/-]+-[A-Za-z0-9_-]{6,}\.(?:js|css)$/.test(url.pathname)) continue
      assets.add(url.pathname)
    } catch {
      // Malformed resource metadata is not a reason to block reopening an acknowledged draft.
    }
  }
  const controller = new AbortController()
  const timeout = setTimeout(() => controller.abort(), 4000)
  try {
    await Promise.allSettled([...assets].slice(-64).map(async (url) => {
      const response = await fetch(url, { cache: "reload", credentials: "same-origin", redirect: "error", signal: controller.signal })
      if (response.ok) await response.arrayBuffer()
    }))
  } finally {
    clearTimeout(timeout)
  }
}
